import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PagePromotions from 'Pages/promotions';
import PagePromotion from 'Pages/promotion';

const Home = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
			<Route exact path={`${match.url}/list`} component={ PagePromotions } />
			<Route exact path={`${match.url}/create`} component={ PagePromotion } />
			<Route exact path={`${match.url}/edit/:promotionId`} component={ PagePromotion } />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default Home;